import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import Icon from "ds/components/Icon";
import { getProviderLogo } from "views/Account/Settings/Users/helpers";

import { CellComponentProps } from "../types";

type IdpGroupUsersListItemMethodCellProps = CellComponentProps;

const IdpGroupUsersListItemMethodCell = ({ user }: IdpGroupUsersListItemMethodCellProps) => {
  const ProviderIcon = getProviderLogo(user.loginMethod);
  return (
    <Box direction="row" align="center">
      {ProviderIcon && (
        <>
          {typeof ProviderIcon === "string" ? (
            <Typography tag="span" variant="p-body3">
              {ProviderIcon}
            </Typography>
          ) : (
            <Icon src={ProviderIcon} size="large" />
          )}
        </>
      )}
    </Box>
  );
};

export default IdpGroupUsersListItemMethodCell;
